/* import __COLOCATED_TEMPLATE__ from './data-validations.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type Action from 'embercom/models/workflow-connector/action';

interface Args {
  workflowAction: Action;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class DataValidations extends Component<Signature> {
  @tracked showValidationWarningModal = false;

  get hasUsedAttributes(): boolean {
    return this.args.workflowAction.usedAttributeArray.length > 0;
  }

  @action
  toggleValidateMissingAttributes() {
    if (this.args.workflowAction.validateMissingAttributes) {
      this.showValidationWarningModal = true;
    } else {
      this.args.workflowAction.validateMissingAttributes = true;
    }
  }

  @action
  confirmDisableValidation() {
    this.args.workflowAction.validateMissingAttributes = false;
    this.closeValidationWarningModal();
  }

  @action
  closeValidationWarningModal() {
    this.showValidationWarningModal = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::Builder::Body::Sections::Request::DataValidations': typeof DataValidations;
    'workflow-connector/builder/body/sections/request/data-validations': typeof DataValidations;
  }
}
